import React from 'react';
import NotificationsNoneIcon from '@mui/icons-material/Notifications';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

export default function NotificationIcons({ notificationCount = 0 }) {
  return (
    <div className="flex items-start gap-3">
      {/* Bildirim ikonu */}
      <button className="relative p-1 rounded hover:bg-gray-100 transition-colors">
        <NotificationsNoneIcon className="text-gray-600 text-2xl sm:text-3xl" />
        {notificationCount > 0 && (
          <span className="absolute -top-1 -right-1 bg-red-500 text-white text-[8px] sm:text-[10px] w-3 h-3 sm:w-4 sm:h-4 flex items-center justify-center rounded-full">
            {notificationCount}
          </span>
        )}
      </button>

      {/* Yardım ikonu */}
      <button className="p-1 rounded hover:bg-gray-100 transition-colors">
        <HelpOutlineIcon className="text-gray-600 text-2xl sm:text-3xl" />
      </button>
    </div>
  );
}
